if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        const productId = this.dataset.productId;
        const cartProductIds = JSON.parse(this.dataset.cartProductIds || '[]');
        const container = this.querySelector('.ohyuk-cart-upsell__items');
        if (!productId || !container) return;

        fetch(`/recommendations/products.json?product_id=${productId}&limit=5&intent=related`)
          .then((r) => r.json())
          .then((data) => {
            const products = (data.products || [])
              .filter((p) => !cartProductIds.includes(p.id))
              .slice(0, 2);
            if (!products.length) {
              this.style.display = 'none';
              return;
            }
            const escapeAttr = (s) => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            container.innerHTML = products
              .map((p) => {
                const priceNumber = p.variants[0].price / 100;
                const price = priceNumber.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                });
                const imgSrc = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image?.src;
                const img = imgSrc ? imgSrc.split('?')[0] + '?width=160' : '';
                return (
                  '<div class="ohyuk-cart-upsell__item">' +
                  (img
                    ? `<img src="${img}" class="ohyuk-cart-upsell__img" width="60" height="60" alt="${escapeAttr(p.title)}">`
                    : '') +
                  `<div class="ohyuk-cart-upsell__info"><span class="ohyuk-cart-upsell__name">${p.title}</span>` +
                  `<span class="ohyuk-cart-upsell__price">${price}</span></div>` +
                  `<button class="ohyuk-cart-upsell__btn" data-vid="${p.variants[0].id}" data-pid="${p.id}" data-pname="${escapeAttr(p.title)}" data-pprice="${priceNumber}">+ Add</button>` +
                  '</div>'
                );
              })
              .join('');

            container.querySelectorAll('.ohyuk-cart-upsell__btn').forEach((btn) => {
              btn.addEventListener('click', () => {
                const vid = btn.dataset.vid;
                const pid = btn.dataset.pid;
                const pname = btn.dataset.pname;
                const pprice = parseFloat(btn.dataset.pprice) || 0;
                btn.textContent = '…';
                btn.disabled = true;
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  body: JSON.stringify({ id: vid, quantity: 1 }),
                })
                  .then(() => {
                    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    btn.textContent = '✓';
                    if (typeof window.gtag === 'function') {
                      window.gtag('event', 'add_to_cart', {
                        currency: 'USD',
                        value: pprice,
                        items: [
                          {
                            item_id: String(pid),
                            item_name: pname,
                            price: pprice,
                            quantity: 1,
                            item_list_id: 'cart_upsell',
                            item_list_name: 'Cart Drawer Upsell',
                          },
                        ],
                      });
                    }
                  })
                  .catch(() => {
                    btn.textContent = '+ Add';
                    btn.disabled = false;
                  });
              });
            });
          })
          .catch(() => {
            this.style.display = 'none';
          });
      }
    }
  );
}
